import React, { useState, useEffect, useContext } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
//import { DateTime } from "luxon"

import { REFERRAL_LIST_PARTICIPANT2, REFERRAL_LIST_ENTITY } from "../queries"
import _ from "lodash"
import { useQuery } from "@apollo/client"
import ParticipantProfileBoxSmall from "../../../components/ParticipantProfileBoxSmall"

// Context
import { UserContext } from "../../../context/userContext"

// New Components
import { useFilters } from "../../../components/Filters/useFilters"
import FilterHeader from "../../../components/DataTable/FilterHeader"
import {
  handleOptsForFilter,
  formatDate,
} from "../../../components/DataTable/helpers"
import { parseDate } from "../../../helpers/dateNormalization"
import LoaderFullPage from "../../../components/Loaders"
// Styles
import formStyles from "../../../styles/Form-Inputs.module.css"
import refEntityStyles from "../../../styles/referrals/ReferralEntityForm.module.css"

//Routes
import ROUTES from "../../../components/Routes/routesContants"

// Prime React
//import { FilterMatchMode, FilterOperator } from "primereact/api"
//import { DataTable } from "primereact/datatable"
//import { Column } from "primereact/column"
//import { InputText } from "primereact/inputtext"
//import { Skeleton } from "primereact/skeleton"
import { SplitButton } from "primereact/splitbutton"
import { Button } from "primereact/button"
import { Calendar } from "primereact/calendar"
// Referral API calls
import {
  refApiRefEntityStatusListPost,
  refApiRefEntityPerUserPost,
} from "../ReferralsAPI"
import ReferralStatusPopup from "./ReferralStatusPopup"
import ReferralEntityStatusPopup from "./ReferralEntityStatusPopup"
import GenericTable from "../../../components/DataTable/GenericTable"

export default function ReferralsList() {
  const location = useLocation()
  const userCtx = useContext(UserContext)

  const navigate = useNavigate()

  const partnerRoles = [9, 10]
  const [isLoading, setIsLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState("")
  //const [globalFilterValue, setGlobalFilterValue] = useState("")
  // const [filters, setFilters] = useState({
  //   global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  //   full_name: {
  //     value: null,
  //     matchMode: FilterMatchMode.CONTAINS,
  //   },
  //   type: {
  //     operator: FilterOperator.AND,
  //     constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
  //   },
  //   referral_entity_name: {
  //     value: null,
  //     matchMode: FilterMatchMode.CONTAINS,
  //   },
  //   status: {
  //     value: null,
  //     matchMode: FilterMatchMode.CONTAINS,
  //   },
  // })

  const [refData, setRefData] = useState([{}])
  const [refEntityStatus, setRefEntityStatus] = useState(undefined)
  const [isLoadingRefEntityStatus, setIsLoadingRefEntityStatus] = useState(true)
  const [selectedRef, setSelectedRef] = useState(undefined)
  const [dateRange, setDateRange] = useState(null)

  const [bigScreen, setbigScreen] = useState(
    window.matchMedia("(min-width: 960px)").matches
  )
  const currentYear = new Date().getFullYear()
  const yearRange = `2000:${currentYear + 10}`
  const {
    filters,
    globalFilterValue,
    onGlobalFilterChange,
    onFilterChange,
    clearGlobalFilter,
    clearAllFilters,
  } = useFilters()

  useEffect(() => {
    //Keep an eye on when the form gets too small for the datatable and let it stack.
    window
      .matchMedia("(min-width: 960px)")
      .addEventListener("change", (e) => setbigScreen(e.matches))
  }, [])

  useEffect(() => {
    setIsLoading(true)
  }, [userCtx.current_participant_id])

  const newReferralLink = ROUTES.FORM_PAGE.replace(
    ":idTemplate",
    "ad_hoc_referral"
  ).replace(":formPage", "1")
  let editReferralLink = ROUTES.REFERRAL_EDIT
  let isParticipant = false
  let query = REFERRAL_LIST_ENTITY
  let queryVars = { referral_entity_ids: [] }

  if (location.pathname === ROUTES.PARTICIPANT_REFERRALS) {
    query = REFERRAL_LIST_PARTICIPANT2
    editReferralLink = ROUTES.PARTICIPANT_REFERRAL_EDIT
    queryVars = {
      pid: userCtx.current_participant_id,
      uid: userCtx.session.user.staff_id || null,
    }
    isParticipant = true
  }

  const { refetch, loading: loadingData } = useQuery(query, {
    variables: queryVars,
    fetchPolicy: "network-only",
    skip: !isParticipant, //This will be manually run after fetching Referral IDs from MS
    onCompleted: (result) => {
      try {
        if (result !== undefined && result.referrals !== null) {
          let dataParsed = JSON.parse(result.referrals.data)
          if (dataParsed.length > 0) {
            const ids = dataParsed.map((x) => {
              return x.idStamp
            })
            const preppedData =
              location.pathname === ROUTES.PARTICIPANT_REFERRALS
                ? dataParsed.map((x) => {
                    return {
                      ...x,
                      refEntityStatus: "Loading...",
                      referral_type: x.values.referral_type || "",
                      referral_status: x.values.referral_status || "",
                      referral_entity_name: x.values.referral_entity_name || "",
                      date: parseDate(x.session_date) || "",
                    }
                  })
                : dataParsed.map((x) => {
                    return {
                      ...x,
                      refEntityStatus: "Loading...",
                      referral_type: x.values.referral_type || "",
                      referral_status: x.values.referral_status || "",
                      referral_entity_name: x.values.referral_entity_name || "",
                      date: parseDate(x.session_date) || "",
                      full_name: `${
                        _.unescape(x.participant?.participant_name_first) || ""
                      } ${
                        _.unescape(x.participant?.participant_name_last) || ""
                      }`,
                    }
                  })
            console.log({ preppedData })
            setRefData(preppedData)
            setIsLoadingRefEntityStatus(true)

            refApiRefEntityStatusListPost(userCtx.token, ids)
              .then((result) => {
                setRefEntityStatus(result)
              })
              .catch((ex) => {
                console.log(ex)

                if (ex.isAxiosError) {
                  if (ex.response !== undefined) {
                    setErrorMessage(
                      "An error ocurred while retrieving the referral partner status: " +
                        ex.response.data
                    )
                  } else {
                    setErrorMessage(
                      "Unable to load partner status: " + ex.message
                    )
                    setRefEntityStatus([])
                  }
                } else {
                  setErrorMessage(ex)
                }
              })
          } else {
            setRefData([])
          }
        } else {
          setRefData([])
        }
        setIsLoading(false)
      } catch (ex) {
        setErrorMessage(ex)
        setIsLoading(false)
      }
    },
    onError: (error) => {
      setErrorMessage(error.message)
      console.log(error)
      setIsLoading(false)
    },
  })

  useEffect(() => {
    if (!isParticipant) {
      refApiRefEntityPerUserPost(
        userCtx.token,
        userCtx.session.user.staff_id,
        userCtx.session.user.organization_id
      )
        .then((result) => {
          const variables = {
            referral_entity_ids: result.map((x) => {
              return x.referralEntityId
            }),
          }
          refetch(variables)
        })
        .catch((ex) => {
          console.log(ex)

          if (ex.isAxiosError) {
            if (ex.response !== undefined) {
              setErrorMessage(
                "An error ocurred while retrieving the Referral partners: " +
                  ex.response.data
              )
            } else {
              setErrorMessage(
                "Unable to retrieve referral partner per user: " + ex.message
              )
              setRefEntityStatus(null)
            }
          } else {
            setErrorMessage(ex)
          }
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    userCtx.token,
    userCtx.session.user.staff_id,
    isParticipant,
    refetch,
    userCtx.current_participant_id,
  ])

  useEffect(() => {
    if (
      refData !== null &&
      refData.length > 0 &&
      refEntityStatus !== undefined &&
      isLoadingRefEntityStatus
    ) {
      setIsLoadingRefEntityStatus(false)
      let preppedData = []
      if (refEntityStatus === null) {
        preppedData = refData.map((x) => {
          return { ...x, refEntityStatus: "Unknown" }
        })
      } else if (refEntityStatus.length > 0) {
        preppedData = refData.map((x) => {
          return {
            ...x,
            refEntityStatus: refEntityStatus.some(
              (y) => y.referralId === x.idStamp
            )
              ? refEntityStatus.filter((y) => y.referralId === x.idStamp)[0]
                  .referralEntityStatus
              : "Pending",
          }
        })
      } else {
        preppedData = refData.map((x) => {
          return { ...x, refEntityStatus: "Pending" }
        })
      }
      setRefData(preppedData)
    }
  }, [refData, refEntityStatus, isLoadingRefEntityStatus])

  // const onGlobalFilterChange = (e) => {
  //   const value = e.target.value
  //   let _filters = { ...filters }
  //   _filters["global"].value = value

  //   setFilters(_filters)
  //   setGlobalFilterValue(value)
  // }

  // const renderHeader = () => {
  //   const disableStatus = [
  //     "Inactive Discharged",
  //     "Inactive Referrals",
  //     "Kiosk Member",
  //   ]

  //   return (
  //     <div style={{ display: "inline-block", width: "100%" }}>
  //       {/* <span className="p-input-icon-left">
  //         <i className="pi pi-search" />
  //         <InputText
  //           value={globalFilterValue}
  //           onChange={onGlobalFilterChange}
  //           placeholder="Keyword Search"
  //         />
  //       </span> */}
  //     </div>
  //   )
  // }

  const actionBodyTemplate = (rowData) => {
    if (rowData.idStamp) {
      return (
        <div style={{ width: "100%" }}>
          {partnerRoles.some(
            (role) => role === userCtx.session.user.staff_role
          ) ? (
            <Button
              label="View"
              onClick={() => {
                navigate(
                  `${editReferralLink.substring(
                    0,
                    editReferralLink.lastIndexOf("/")
                  )}/${rowData.idStamp}&pid=${rowData.participant_id}`
                )
              }}
              style={{ float: "right" }}
              disabled={isLoading}
            />
          ) : (
            <SplitButton
              label="View"
              onClick={() => {
                navigate(
                  `${editReferralLink.substring(
                    0,
                    editReferralLink.lastIndexOf("/")
                  )}/${rowData.idStamp}&pid=${rowData.participant_id}`
                )
              }}
              style={{ float: "right" }}
              disabled={isLoading}
              model={[
                {
                  label: "Update status",
                  command: () => {
                    setSelectedRef(rowData)
                  },
                },
              ]}
            />
          )}
        </div>
      )
    } else {
      return null
    }
  }

  const StatusPopup = () => {
    if (partnerRoles.some((role) => role === userCtx.session.user.staff_role)) {
      return (
        <ReferralEntityStatusPopup
          showEntityStatusUpdate={!!selectedRef}
          setShowEntityStatusUpdate={() => {
            setSelectedRef(undefined)
          }}
          referralEntityId={selectedRef?.values?.referral_entity_id}
          referralOrganizationId={selectedRef?.organization_id}
          referralId={selectedRef?.idStamp}
          setRefStatus={(refStatus, newStatus, note) => {
            let newRef = { ...selectedRef }
            newRef.refEntityStatus = refStatus
            newRef.values.referral_status = newStatus

            setRefData(
              refData.map((referral) =>
                referral.idStamp === newRef.idStamp ? newRef : referral
              )
            )
          }}
          referralCreatorStaffId={selectedRef?.staff_id || ""}
          referralParticipantId={selectedRef?.participant_id || ""}
          referralOrganizationID={selectedRef?.organization_id || ""}
          currentEntityStatus={selectedRef?.refEntityStatus}
          currentReferralStatus={selectedRef?.values?.referral_status}
          currentReferralParticipantNote={
            selectedRef?.values?.referral_participants_notes
          }
        />
      )
    } else {
      return (
        <ReferralStatusPopup
          showForm={!!selectedRef}
          onHideForm={() => {
            setSelectedRef(undefined)
          }}
          onStatusChanged={(newStatus) => {
            let newRef = { ...selectedRef }
            newRef.values.referral_status = newStatus

            setRefData(
              refData.map((referral) =>
                referral.idStamp === newRef.idStamp ? newRef : referral
              )
            )
            setSelectedRef(undefined)
          }}
          referralIdStamp={selectedRef?.idStamp}
          referralOrganizationId={selectedRef?.organization_id}
          referralStatus={selectedRef?.values?.referral_status}
          referralEntityId={selectedRef?.values?.referral_entity_id}
          referralParticipantsNotes={
            selectedRef?.values?.referral_participants_notes
          }
        />
      )
    }
  }

  if (
    !userCtx.participant_id &&
    userCtx.session.user.organization_type !== "PARTNER"
  ) {
    return (
      <>
        <h1>Referrals</h1>
        <h3>Please select a participant</h3>
      </>
    )
  }
  if (isLoading || loadingData) return <LoaderFullPage />

  const uniqueReferralTypes = handleOptsForFilter(refData, "referral_type")
  const uniqueReferralStatus = handleOptsForFilter(refData, "referral_status")
  const uniqueReferralPartners = handleOptsForFilter(
    refData,
    "referral_entity_name"
  )

  const filterConfig = [
    {
      label: "Date",
      value: dateRange,
      options: null,
      onChange: (e) => {
        setDateRange(e.value)
        onFilterChange("date", e.value)
      },
      onClear: () => {
        setDateRange(null)
        onFilterChange("date", null)
      },
      enableFilter: true,
      component: (
        <Calendar
          value={dateRange}
          onChange={(e) => {
            setDateRange(e.value)
            onFilterChange("date", e.value)
          }}
          placeholder="Select Date Range"
          selectionMode="range"
          dateFormat="mm/dd/yy"
          readOnlyInput
          numberOfMonths={2}
          showIcon
          showButtonBar
          yearNavigator
          yearRange={yearRange}
        />
      ),
    },
    {
      label: "Referral Type",
      value: filters.referral_type?.value || "",
      options: uniqueReferralTypes,
      onChange: (e) => onFilterChange("referral_type", e.value),
      onClear: () => onFilterChange("referral_type", null),
      enableFilter: true,
    },
    {
      label: "Referral Status",
      value: filters.referral_status?.value || "",
      options: uniqueReferralStatus,
      onChange: (e) => onFilterChange("referral_status", e.value),
      onClear: () => onFilterChange("referral_status", null),
    },
    {
      label: "Referral Partner",
      value: filters.referral_entity_name?.value || "",
      options: uniqueReferralPartners,
      onChange: (e) => onFilterChange("referral_entity_name", e.value),
      onClear: () => onFilterChange("referral_entity_name", null),
    },
  ]

  const columns = [
    {
      field: "date",
      header: "Date",
      sortable: true,
      body: (rowData) => formatDate(rowData.date),
    },
    { field: "referral_type", header: "Referral Type", sortable: true },
    {
      field: "referral_status",
      header: "Referral Status",
      sortable: true,
    },
    {
      field: "referral_entity_name",
      header: "Referral Partner",
      sortable: true,
    },

    {
      field: "refEntityStatus",
      header: "Referral Partner Status",
      sortable: true,
    },
    {
      field: "staff_full_name",
      header: "Facilitating Staff",
      sortable: true,
    },
    {
      field: "action",
      header: "",
      frozen: true,
      style: { width: "100px" },
      resizeable: false,
      body: actionBodyTemplate,
    },
  ]
  const disableStatus = [
    "Inactive Discharged",
    "Inactive Referrals",
    "Kiosk Member",
  ]

  const handleClearAllFilters = () => {
    clearAllFilters()
    setDateRange(null)
  }
  //NOTE: Filter data based on context
  return (
    <div className="main-content">
      {userCtx.session.user.organization_type !== "PARTNER" ? (
        <ParticipantProfileBoxSmall />
      ) : null}
      <h1>Referrals</h1>
      {userCtx.session.user.staff_role < 9 &&
      !disableStatus.includes(userCtx.participant_membership_status) ? (
        <Link
          to={newReferralLink}
          className="btn"
          style={{ marginBottom: "15px" }}
        >
          New Referral
        </Link>
      ) : null}
      {errorMessage !== "" ? (
        <div style={{ marginBottom: "20px" }}>
          <label className={formStyles.errFieldMsg}>{errorMessage}</label>
        </div>
      ) : null}

      <StatusPopup />

      <GenericTable
        //header={renderHeader}
        filters={filters}
        // globalFilterFields={[
        //   "template_title",
        //   "values.referral_type",
        //   "values.referral_entity_name",
        //   "values.referral_status",
        //   "refEntityStatus",
        // ]}\
        header={
          <FilterHeader
            filters={filterConfig}
            globalFilterValue={globalFilterValue}
            onGlobalFilterChange={onGlobalFilterChange}
            clearGlobalFilter={clearGlobalFilter}
            clearAllFilters={handleClearAllFilters}
          />
        }
        data={refData}
        columns={columns}
        // value={isLoading ? Array.from({ length: 5 }) : refData}
        paginator
        rows={50}
        rowClassName={bigScreen ? "" : refEntityStyles.stackedDataTable}
      ></GenericTable>
    </div>
  )
}